import back from "../img/back.png";
import knees from "../img/knees.png";
import none from "../img/none.png";

export const DATA = {
  "Sensitive back": back,
  "Sensitive knees": knees,
  "None of the above": none,
};
